import { Box, FormControlLabel, Grid, IconButton, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import MROButton from 'components/buttons';
import PositiveSwitch from 'components/form_components/switch';
import MROTextField from 'components/form_components/TextField';
import MaterialTable from 'material-table';
import React, { useContext, useEffect, useState } from 'react'
import useQuoteStyles from '../utils/QuoteStyles';
import { ToastMessageContext } from 'lib/contexts/message_context';
import AddIcon from "@material-ui/icons/Add";
import AddIconBox from "@material-ui/icons/AddBox";
import tableIcons, { options } from 'components/universal/table_attributes';
import SearchIcon from "@material-ui/icons/Search";
import { ICON_COLOUR } from 'lib/constants/style_constants';
import DeleteIcon from "@material-ui/icons/Delete";
import { getOrganisationId } from 'lib/utils/common_utils';
import { MaintenanceServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation';
import ManagePrimaryParts from '../../QuotePopUp/ManagePrimaryParts';
import CreateProjectParts from '../../QuotePopUp/CreateProjectParts';
import PartPricing from '../../Commercial/LookupPricing/PartPricing';





export default function ProjectPartSection(props) {
    const {
        errors,
        setErrors,
        resetErrorsHandler,
        disabled,
        access,
        quotation,
        handlePopup,
        selectedPart,
        setSelectedPart,
        loading,
        actions,
        setActions,
        quoteStatus,
        input,
        setInput,
        disabledAccptance,
        selectedCustomerId,
        cusExist,
        setExistCus,
        currentSelectedData,
        setCurrentSelectedData,
        setRate,
        projectParts,
        setProjectParts,
        salesRate,
        setLoading,
        setQty,
        projectState,
        setProjectstate,
        action,
        workshop_order_id,
        rate,
        quoteId,
        reportableType,
        setReportableType,
        priceBreakDetails,
        setQuantityPrice
    } = props;
    const [serialNumber, setSerialNumber] = useState(null);


    const [projectLoading, setProjectLoading] = useState(false)
    const classes = useQuoteStyles()
    const message = useContext(ToastMessageContext)
    const [description, setDescription] = useState(null)
    const [primePart, setPrimePart] = useState([])





    useEffect(() => {
        if (quotation !== undefined) {
            setDescription(quotation?.item_description)
            setSerialNumber(quotation?.serial_number);

        }
    }, [quotation]);


    const tableOptions1 = {
        ...options,
        paging: false,
        search: false,
        toolbar: true,
        actionsColumnIndex: 10,
        headerStyle: {
            textAlign: "center",

        },
        cellStyle: {
            textAlign: "center",


        }
    };
    const columns1 = [
        {
            title: "Item",
            field: "item",
            width: "4%",
            editable: "never"
            // render: (rowData) => <span>&nbsp;</span>,
        },
        {
            title: "Part #",
            field: "part_number",
            editable: "never",
            headerStyle: {
                textAlign: "left",
                width: "12%"
            },
            cellStyle: {
                textAlign: "left",

                width: "12%"
            }
        },
        {
            title: "Description",
            field: "description",
            editable: "never",
            headerStyle: {
                textAlign: "left",
                width: "40%"
            },
            cellStyle: {
                textAlign: "left",
                paddingLeft: '15px',
                width: "40%"
            }
        },
        {
            title: "Labour",
            field: "project_parts_labour",
            editable: "onUpdate",
            render: (rowData) => rowData.project_parts_labour ? rowData?.project_parts_labour : "0.00",
        },
        {
            title: "Parts",
            field: "project_parts_parts",
            editable: "onUpdate",
            render: (rowData) => rowData?.project_parts_parts ? rowData?.project_parts_parts : "0.00",
        },
        {
            title: "Services",
            field: "project_parts_services",
            editable: "onUpdate",
            render: (rowData) => rowData?.project_parts_services ? rowData?.project_parts_services : "0.00",
        },
        {
            title: "Equip",
            field: "project_parts_equipment",
            editable: "onUpdate",
            render: (rowData) => rowData.project_parts_equipment ? rowData?.project_parts_equipment : "0.00",
        },
        {
            title: "Unit Price",
            field: "project_parts_unit_price",
            editable: "never",
            render: (rowData) => rowData.project_parts_unit_price ? rowData?.project_parts_unit_price : "0.00",
        }, {
            title: "Quantity",
            field: "quantity",

            editable: "onUpdate",
            // render: (rowData) => rowData.discount ? `${rowData.discount}%` : '',
        }, {
            title: "Total",
            field: "project_parts_total",
            editable: "never",
            render: (rowData) => rowData.project_parts_total ? rowData?.project_parts_total : 0.0,
        },

        {
            title: "",
            field: "actual_man_hours",
            headerStyle: {
                textAlign: "left",
            },
            cellStyle: {
                textAlign: "left",

            },
            render: (rowData) =>
                <Box style={{ marginLeft: '-31px', display: 'flex' }}>
                    {!disabled ? <>
                        <IconButton
                            disabled={!props.permission.write || disabled}
                            style={{ display: !props.permission.write && "none" }}
                            onClick={() => {

                                if (cusExist === "yes") {
                                    if (selectedCustomerId?.id !== undefined) {
                                        setCurrentSelectedData(rowData)
                                        setRate(selectedCustomerId?.currency?.sales_rate)
                                        setActions("project_lookup")
                                    }
                                    else {
                                        message.showToastMessage({
                                            message: "Select Customer First!",
                                            variant: "error",
                                        });

                                    }

                                }
                                else if (cusExist === "no") {


                                    setActions("project_lookup")
                                    setCurrentSelectedData(rowData)


                                }






                            }}
                        >
                            <SearchIcon fontSize="small" htmlColor={ICON_COLOUR} />
                        </IconButton>

                        <IconButton
                            disabled={!props.permission.write || disabled}
                            onClick={() => {
                                handleDelete(rowData);
                            }}
                        >
                            <DeleteIcon fontSize="small" htmlColor={ICON_COLOUR} />
                        </IconButton></> : ""}
                </Box >
        }

    ];


    useEffect(() => {
        getPartDetails()
    }, [projectState])

    const getPartDetails = () => {
        let params = {}
        if (projectState) {
            params = {
                organisation_id: getOrganisationId(),
                active: true,
                repairable: true,
                project_part: true,
                status: true,
            }

        }
        else {
            params = {
                organisation_id: getOrganisationId(),
                active: true,
                repairable: true,
                status: true,
                project_part: false
            }
        }


        MaintenanceServices.getPartNumber(params)
            .then((res) => {
                setPrimePart(res.data)
            }).catch(() => {
                console.log("error")
            })
    }

    useEffect(() => {
        setDescription(!selectedPart?.description ? "" : selectedPart?.description)
    }, [selectedPart?.description])
    //  Selected project parts

    // console.log("quoteId======", quoteId)
    // Condition 1: quoteStatus is false + quoteId is null+part search → call by primaryPart
    // Condition 2: quoteStatus is false + quoteId exists + projectParts.length > 0 → call by workshopOrder
    // Condition 3: quoteStatus is false + quoteId exists + projectParts.length === 0 + part search → call by primaryPart
    // Condition 4: quoteStatus is true → call by workshopOrder




    console.log("condition 1", reportableType)
    useEffect(() => {
        if (action === "Unlock") {
            setReportableType("WorkshopOrder")
        }

    }, [action])



    useEffect(() => {
        let params = {}
        if (!projectState || selectedPart === null || (reportableType === null && !quoteStatus)) {
            if (quoteStatus === false && projectState && selectedPart === null) {
                setProjectParts([]);
            }
            return;
        }

        else if (!quoteStatus && selectedPart && reportableType === "PrimaryPart") {
            params = {
                organisation_id: getOrganisationId(),
                reportable_id: selectedPart.id,
                reportable_type: "PrimaryPart"
            }

        }
        else if (!quoteStatus && selectedPart && reportableType === "WorkshopOrder") {

            params = {
                organisation_id: getOrganisationId(),
                reportable_id: workshop_order_id || quotation?.workshop_order_id,
                reportable_type: "WorkshopOrder"
            };


        }


        else if (quoteStatus === true && selectedPart !== null) {
            // Condition 4: quoteStatus is true → call by workshopOrder
            params = {
                organisation_id: getOrganisationId(),
                reportable_id: workshop_order_id || quotation?.workshop_order_id,
                reportable_type: "WorkshopOrder"
            };

        }
        getProjectParts(params);

    }, [selectedPart, workshop_order_id, reportableType]);



    const getProjectParts = async (params) => {
        const params1 = {
            organisation_id: getOrganisationId(),
            reportable_id: workshop_order_id || quotation?.workshop_order_id,
            // project_primary_part_id: selectedPart.id,
            reportable_type: "WorkshopOrder"

        }
        setProjectLoading(true)

        await MaintenanceServices.getAllProjectParts(params ? params : params1)
            .then((res) => {
                if (res) {

                    if (params?.reportable_type === "PrimaryPart" && res?.data.length > 0) {
                        let data = res?.data
                        let rate = selectedCustomerId?.currency?.sales_rate || salesRate



                        let value = data.map((item) => {

                            let equip = item.workshop_standard_pricing_equipment ? parseFloat(item.workshop_standard_pricing_equipment) / parseFloat(rate).toFixed(2) : 0.00

                            let labour = item.workshop_standard_pricing_labour ? parseFloat(item.workshop_standard_pricing_labour) / parseFloat(rate).toFixed(2) : 0.00

                            let parts = item.workshop_standard_pricing_parts ? parseFloat(item.workshop_standard_pricing_parts) / parseFloat(rate).toFixed(2) : 0.00
                            let services = item.workshop_standard_pricing_services ? parseFloat(item.workshop_standard_pricing_services) / parseFloat(rate).toFixed(2) : 0.00

                            let total = item.workshop_standard_pricing_total ? parseFloat(item.workshop_standard_pricing_total) / parseFloat(rate).toFixed(2) : 0.00
                            let unit_price = item.workshop_standard_pricing_unit_price ? parseFloat(item.workshop_standard_pricing_unit_price) / parseFloat(rate).toFixed(2) : 0.00

                            item.project_parts_equipment = parseFloat(equip).toFixed(2)
                            item.project_parts_labour = parseFloat(labour).toFixed(2)
                            item.project_parts_parts = parseFloat(parts).toFixed(2)
                            item.project_parts_services = parseFloat(services).toFixed(2)
                            item.project_parts_total = parseFloat(total).toFixed(2)
                            item.project_parts_unit_price = parseFloat(unit_price).toFixed(2)



                            return item
                        }


                        )
                        setProjectParts(value)

                    } else {
                        setProjectParts(res.data);
                    }
                }
                // setLoading(false);
            })
            .catch((err) => {
                message.showToastMessage({
                    message: "Something went wrong. Try again!",
                    variant: "error",
                });
                // setLoading(false);
            }).finally(() => {
                setProjectLoading(false)
            })
    };
    useEffect(() => {
        if (projectState === true) {
            setQty(1)
        }
    }, [projectState])

    const handleDelete = (rowData) => {

        if (quoteStatus === false && quoteId === undefined || reportableType === "PrimaryPart") {
            const filtered = projectParts.filter((item) => item.item !== rowData.item);
            const updated = filtered.map((item, index) => ({
                ...item,
                item: index + 1
            }));
            setProjectParts(updated);

        } else {
            const params = {
                organisation_id: getOrganisationId(),
                reportable_id: quotation?.workshop_order_id,
                primary_part_id: rowData?.primary_part_id,
                reportable_type: "WorkshopOrder",
                project_primary_part_id: selectedPart.id,
            }


            setLoading(true)
            MaintenanceServices.deleteWOProjectParts(params).then((res) => {
                if (res.success) {
                    message.showToastMessage({
                        message: "Deleted Successfully !",
                        variant: "success",
                    });
                    getProjectParts()
                }
                else {
                    message.showToastMessage({
                        message: res?.error ? res?.error : "Something went wrong. Try again!",
                        variant: "error",
                    });
                }

            }).catch((res) => {
                message.showToastMessage({
                    message: res?.error ? res?.error : "Something went wrong. Try again!",
                    variant: "error",
                });
            }).finally(() => {
                setLoading(false)
            })




        }


    }




    const handleProjectUpdate = (rowData, oldData) => {
        let labour = parseFloat(rowData.project_parts_labour || 0.00).toFixed(2)
        let parts = parseFloat(rowData.project_parts_parts || 0.00).toFixed(2)
        let services = parseFloat(rowData.project_parts_services || 0.00).toFixed(2)
        let equip = parseFloat(rowData.project_parts_equipment || 0.00).toFixed(2)

        let unit_price = (+labour) + (+ parts) + (+ services) + (+equip)
        let quantity = rowData.quantity || 0.00
        let total = parseFloat(unit_price) * parseFloat(quantity)

        if (quoteStatus === false && quoteId === undefined || reportableType === "PrimaryPart") {
            let value = projectParts.map((item) => {
                if (item.item === rowData.item) {
                    item.project_parts_labour = labour
                    item.project_parts_parts = parts
                    item.project_parts_services = services
                    item.project_parts_equipment = equip
                    item.quantity = quantity
                    item.project_parts_unit_price = unit_price
                    item.project_parts_total = total ? parseFloat(total).toFixed(2) : 0.00
                }
                return item
            })
            setProjectParts(value)

        } else {
            const params = {
                organisation_id: getOrganisationId(),
                reportable_id: quotation?.workshop_order_id,
                project_primary_part_id: selectedPart.id,
                reportable_type: "WorkshopOrder",
                primary_part_id: rowData?.primary_part_id,
                labour: labour,
                parts: parts,
                services: services,
                equipment: equip,
                quantity: quantity,
                project_parts_total: total,


            }
            MaintenanceServices.updateWOProjectParts(params).then((res) => {
                if (res.success) {
                    message.showToastMessage({
                        message: "Updated Successfully !",
                        variant: "success",
                    });
                    getProjectParts()
                }
                else {
                    message.showToastMessage({
                        message: res?.error ? res?.error : "Something went wrong. Try again!",
                        variant: "error",
                    });

                }
            }).catch((res) => {
                message.showToastMessage({
                    message: res?.error ? res?.error : "Something went wrong. Try again!",
                    variant: "error",
                });
            })



        }



    }

    useEffect(() => {
        if (projectParts?.length > 0 && projectState) {
            const totals = projectParts.reduce(
                (acc, item) => {
                    const quantity = +item.quantity || 0; // Safely handle quantity being 0 or undefined
                    acc.labour += item.project_parts_labour ? (+item.project_parts_labour * quantity) : 0;
                    acc.parts += item.project_parts_parts ? (+item.project_parts_parts * quantity) : 0;
                    acc.services += item.project_parts_services ? (+item.project_parts_services * quantity) : 0;
                    acc.equipment += item.project_parts_equipment ? (+item.project_parts_equipment * quantity) : 0;
                    return acc;
                },
                { labour: 0, parts: 0, services: 0, equipment: 0 }
            );

            // Set the input state with the computed totals, formatted to 2 decimal places
            setInput({

                labour: parseFloat(totals.labour).toFixed(2),
                parts: parseFloat(totals.parts).toFixed(2),
                services: parseFloat(totals.services).toFixed(2),
                equipment: parseFloat(totals.equipment).toFixed(2),
                aog_fee: input.aog_fee
            });

            // Set errors as false for all fields
            setErrors({ labour: false, parts: false, services: false, equipment: false });
        }
    }, [projectParts]);






    return (
        <>
            <div>
                <FormControlLabel
                    control={
                        <PositiveSwitch
                            disabled={disabled || !props?.permission.write || (quoteId && projectState && quoteStatus)}
                            defaultChecked={quotation?.project_part}
                            // className={access.read ? classes.disableField : null}
                            checked={projectState}
                            // value={switchState}
                            InputProps={{
                                className:
                                    quoteId && projectState ? classes.disableField : disabledAccptance && classes.disableField,
                            }}

                            // name="project_state"
                            onChange={(e) => {
                                if (!projectState && priceBreakDetails.length > 1) {
                                    message.showToastMessage({
                                        message: "Remove price breaks first!",
                                        variant: "error",
                                    });
                                    return;
                                }
                                else if (projectState && projectParts.length > 0) {
                                    message.showToastMessage({
                                        message: "Remove project parts first!",
                                        variant: "error",
                                    });
                                    return;
                                }
                                else if (e.target.checked === true) {
                                    setQuantityPrice('no');
                                }
                                setProjectstate(e.target.checked);

                                setSelectedPart({})
                                setDescription("")
                                setInput({
                                    labour: "",
                                    parts: "",
                                    services: "",
                                    equipment: "",
                                });

                                handlePopup();
                            }}
                        />
                    }
                    label={
                        <Typography
                            variant="body2"
                            style={{ marginLeft: "-13px" }}
                        >
                            Project / Multi Part Workshop Order?
                        </Typography>
                    }
                    labelPlacement="start"

                />
            </div>
            {
                (!projectState || projectState) &&
                <Grid
                    style={{ marginBottom: "20px", width: "100%" }}
                    container
                    spacing={3}
                    alignItems={"center"}
                    justify={"flex-start"}
                >
                    <Grid className={classes.purchaseGrid} item xs={3}>
                        <Autocomplete
                            disabled={disabled || !props.permission.write ||
                                (quoteId && projectState && quoteStatus) ||
                                (quoteId !== null && !quoteStatus && projectParts.length > 0 && reportableType === "WorkshopOrder")}
                            getOptionSelected={(option, value) => option.id === value.id}
                            value={selectedPart !== null && selectedPart}
                            onChange={(event, value) => {
                                setReportableType("PrimaryPart")

                                if (cusExist === "yes" && projectState) {
                                    if (selectedCustomerId?.id !== undefined) {
                                        setSelectedPart(value);
                                        handlePopup();
                                    }
                                    else {
                                        message.showToastMessage({
                                            message: "Select Customer First!",
                                            variant: "error",
                                        });
                                        setSelectedPart({});
                                    }

                                }
                                else if (cusExist === "no" && projectState) {
                                    message.showToastMessage({
                                        message: "Select Customer First!",
                                        variant: "error",
                                    });
                                    setSelectedPart({});
                                }
                                else if (!projectState) {
                                    setSelectedPart(value);
                                    handlePopup();
                                }
                            }}
                            id="tags-standard"
                            options={primePart || []}
                            // loading={loading}
                            getOptionLabel={(option) => option?.part_number || ""}
                            renderInput={(params) => (
                                <MROTextField
                                    {...params}
                                    style={{ backgroundColor: "#fff", height: "54px", pointerEvents: !props.permission.write }}
                                    variant="outlined"
                                    name="part_number"
                                    defaultValue="Select"
                                    placeholder={"Search and Select"}
                                    label="Part Number *"
                                    color={"primary"}
                                    InputProps={{
                                        ...params.InputProps,
                                        type: "search",
                                        className: (quoteId && projectState && quoteStatus) && classes.disableField,
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    error={errors.part_number}
                                    onSelect={() => {
                                        resetErrorsHandler("part_number");
                                        handlePopup();
                                    }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid className={classes.purchaseGrid} item xs={3} style={{ marginBottom: "7px" }}>
                        <MROTextField
                            name={"item_description"}
                            label={"Item Description"}
                            // disabled={!props.permission.write}
                            InputProps={{
                                className: classes.disableFieldDesc,
                            }}
                            inputProps={{ style: { textTransform: "uppercase" } }}
                            onChange={(e) => {
                                handlePopup();
                            }}
                            value={description}
                            InputLabelProps={{ shrink: true }}
                        ></MROTextField>
                    </Grid>

                    {!projectState &&

                        <Grid className={classes.purchaseGrid} item xs={3} style={{ marginTop: "-9px" }}>
                            <MROTextField
                                name={"serial_number"}
                                label={"Serial Number *"}
                                disabled={!props.permission.write}
                                InputProps={{
                                    className: disabled && classes.disableField,
                                }}
                                inputProps={{
                                    maxLength: 50,
                                }}
                                error={errors.serial_number}
                                // required
                                value={serialNumber}
                                placeholder={"Serial Number"}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => {
                                    setSerialNumber(e.target.value);
                                    resetErrorsHandler("serial_number");
                                    handlePopup();
                                }}
                            />

                        </Grid>}

                    <Grid className={classes.purchaseGrid} item xs={2}>
                        <MROButton
                            disabled={disabled || !props.permission.write || projectState}
                            type="button"
                            variant={"contained"}
                            onClick={() => setActions("Add")}
                            color="secondary"
                            startIcon={<AddIcon size="small" />}
                        >
                            Add Part
                        </MROButton>
                    </Grid>
                </Grid>
            }
            {
                projectState &&
                <div style={{ marginBottom: "15px" }}>
                    <MaterialTable
                        style={{ boxShadow: "0px 1px 3px #00000033", marginTop: "10px" }}
                        icons={tableIcons}
                        title={""}
                        isLoading={projectLoading}
                        columns={columns1}
                        data={projectParts || []}
                        options={tableOptions1}
                        localization={{
                            body: {
                                emptyDataSourceMessage: "No Records Found",
                            },
                        }}
                        editable={
                            props?.permission.write ? {
                                isEditHidden: rowData => disabled,
                                isEditable: rowData => !disabled,
                                onRowUpdate: (newData, oldData) =>
                                    new Promise((resolve, reject) => {
                                        handleProjectUpdate(newData, oldData)
                                        resolve();
                                    }),
                            } : {}
                        }
                        actions={props?.permission.write && [
                            {
                                icon: () => (
                                    <div style={{ display: access.read ? "none" : undefined }}>
                                        <AddIconBox color="secondary" />
                                    </div>
                                ),
                                tooltip: "Add",
                                hidden: disabled,
                                isFreeAction: true,
                                onClick: () =>
                                    setActions('add_parts'),
                            },
                        ]}
                    />


                </div>
            }

            {actions && actions === 'Add' &&
                <ManagePrimaryParts
                    handleClose={() => setActions(null)}
                    action={actions}
                    primePart={primePart}
                    getPartDetails={getPartDetails}
                    setSelectedPart={setSelectedPart}
                    setDescription={setDescription}
                    projectPartState={projectState}
                />}
            {actions && actions === 'add_parts' &&
                <CreateProjectParts
                    handleClose={() => setActions(null)}
                    action={actions}
                    primePart={primePart}
                    getPartDetails={getProjectParts}
                    projectPartState={projectState}
                    id={workshop_order_id || quotation?.workshop_order_id}
                    primeId={selectedPart}
                    tab={"quote"}
                    quoteStatus={quoteStatus}
                    projectParts={projectParts}
                    quoteId={quoteId}
                    setProjectParts={setProjectParts}

                    reportableType={reportableType}
                />}

            {actions && actions === "project_lookup" && (
                <PartPricing
                    handleClose={() => {
                        if (quoteStatus === false) {
                            setActions(null)
                        }
                        else {
                            setActions(null)
                            getProjectParts()
                        }
                    }}
                    currentWorkshopDetails={{
                        quantity: "1",
                        part_number: currentSelectedData?.part_number,
                        description: currentSelectedData?.description,
                        salesRate: cusExist === "no" ? "1" : rate
                    }}
                    setInput={setInput}
                    input={input}
                    name={"project_lookup"}
                    salesRate={salesRate}
                    projectParts={projectParts}
                    currentSelectedData={currentSelectedData}
                    setProjectParts={setProjectParts}
                    quoteStatus={quoteStatus}
                    workshop_order_id={workshop_order_id || quotation?.workshop_order_id}
                />

            )}

        </>
    )
}
